export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-3">
                <span className="text-xl md:text-2xl font-bold font-heading text-accent-500">
                  7788
                </span>
                <span className="text-sm text-background-300">电影网</span>
              </div>
              <p className="text-xs md:text-sm text-background-400 leading-relaxed">
                7788电影网提供电影大全、最新电影、热门电影高清免费在线观看，电影排行榜实时更新，高清流畅不缓冲，海量电影免费看。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold font-heading text-background-100 mb-3">
                快速导航
              </h4>
              <div className="flex flex-col gap-2">
                <a href="#hero" className="text-xs md:text-sm text-background-400 hover:text-accent-500 transition-colors whitespace-nowrap">首页</a>
                <a href="#ranking" className="text-xs md:text-sm text-background-400 hover:text-accent-500 transition-colors whitespace-nowrap">电影排行榜</a>
                <a href="#cards" className="text-xs md:text-sm text-background-400 hover:text-accent-500 transition-colors whitespace-nowrap">新片速递</a>
                <a href="#faq" className="text-xs md:text-sm text-background-400 hover:text-accent-500 transition-colors whitespace-nowrap">常见问题</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold font-heading text-background-100 mb-3">
                热门标签
              </h4>
              <div className="flex flex-wrap gap-1.5">
                {['科幻', '悬疑', '动作', '喜剧', '动画', '港片', '好莱坞'].map((tag) => (
                  <a
                    key={tag}
                    href="#topics"
                    className="px-2.5 py-1 rounded-full bg-background-800 text-xs text-background-300 hover:bg-accent-500 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold font-heading text-background-100 mb-3">
                合作伙伴
              </h4>
              <p className="text-xs text-background-500">
                暂无具体合作方信息
              </p>
              <h4 className="text-sm font-bold font-heading text-background-100 mt-5 mb-3">
                关注我们
              </h4>
              <div className="flex items-center gap-3">
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-mail-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2018 - 2026 7788电影网 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">用户协议</a>
              <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}